export const ONLY_NUMBERS_REGEX = /\D/g;
